import React, { Component } from 'react';
import { Container, Icon } from 'semantic-ui-react'
import AppRoutes from './routes'
import { connect } from 'react-redux'
import { cleanStore } from './localStore'
import { withRouter, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

// import './App.css';
import './genericStyles.css'
import 'semantic-ui-css/semantic.min.css'

import { Button } from 'semantic-ui-react'
import logo from './images/logo_white.svg';


class App extends Component {
  state = {
    isLoggerdIn: false,
    banco: '',
    isValid: false
  }

  static propTypes = {
    isLoggerdIn: PropTypes.bool
  }

  static defaultProps = {
    isLoggerdIn: false
  }

  componentWillMount() {
    const {
      isLoggerdIn
    } = this.props;
    // this.setState({ isValid: false });
    console.log(process.env.NODE_ENV);
    let banco = '';
    let isValid = false;
    if (window.location.pathname === '/') {
      this.setState({ banco: 'credility' });
    } else {
      banco = window.location.pathname.split('/')[1];
      switch (banco) {
        case 'bst':
          isValid = true;
          break;
        case 'columbia':
          isValid = true;
          break;
        case 'redcloud':
          isValid = true;
          break;
        case 'iaja':
          isValid = true;
          break;
        case 'interfinanzas':
          isValid = true;
          break;
        case 'ciudad':
          isValid = true;
          break;
        case 'cmf':
          isValid = true;
          break;
        case 'came':
          isValid = true;
          break;
        case 'bacs':
          isValid = true;
          break;
        case 'mills':
          isValid = true;
          break;
        case 'acindarpymes':
          isValid = true;
          break;
        case 'mariva':
          isValid = true;
          break;
        case 'bvds':
          isValid = true;
          break;
        case 'agilis':
          isValid = true;
          break;
        case 'directo':
          isValid = true;
        break;
          case 'comafi':
          isValid = true;
          break;
        case 'celesol':
          isValid = true;
          break;
        case 'bice':
          isValid = true;
          break;
        case 'credility':
          isValid = true;
          break;
        default:
          isValid = false;
          break;
      }
      if (isValid) {
        // this.setState({ banco: banco, isValid: isValid });
        // let url = window.location.origin + '/' + banco + '.ico';
        let url = './' + banco + '.ico';
        console.log(url)
        this.changeFavicon(url)
      }
      // else
      //   this.setState({ isValid: isValid });
    }
    this.setState({
      isLoggerdIn: isLoggerdIn,
      banco: banco, isValid: isValid
    })

    // if (isLoggerdIn) {
    //   this.setState({
    //     isLoggerdIn: isLoggerdIn
    //   })

  }


  componentWillReceiveProps(nextProps) {
    const {
      isLoggerdIn
    } = nextProps;

    let banco = window.location.pathname.split('/')[1];
    let isValid = false;
    switch (banco) {
      case 'bst':
        isValid = true;
        break;
      case 'columbia':
        isValid = true;
        break;
      case 'iaja':
        isValid = true;
        break;
      case 'interfinanzas':
        isValid = true;
        break;
      case 'ciudad':
        isValid = true;
        break;
      case 'cmf':
        isValid = true;
        break;
      case 'redcloud':
        isValid = true;
        break;
      case 'came':
        isValid = true;
        break;
      case 'bacs':
        isValid = true;
        break;
      case 'mills':
        isValid = true;
        break;
      case 'acindarpymes':
        isValid = true;
        break;
      case 'mariva':
        isValid = true;
        break;
      case 'bvds':
        isValid = true;
        break;
      case 'agilis':
        isValid = true;
        break;
      case 'directo':
        isValid = true;
        break;
      case 'comafi':
        isValid = true;
        break;
      case 'celesol':
        isValid = true;
        break;
      case 'bice':
        isValid = true;
        break;
      case 'credility':
        isValid = true;
        break;
      default:
        isValid = false;
        break;
    }
    // if (isValid)
    //   this.setState({ banco: banco, isValid: isValid });
    // else
    //   this.setState({ isValid: isValid });
    this.setState({
      isLoggerdIn: isLoggerdIn,
      banco: banco, isValid: isValid
    })
  }

  changeFavicon = link => {
    let $favicon = document.querySelector('link[rel="icon"]')
    // If a <link rel="icon"> element already exists,
    // change its href to the given link.
    if ($favicon !== null) {
      $favicon.href = link
      // Otherwise, create a new element and append it to <head>.
    } else {
      $favicon = document.createElement("link")
      $favicon.rel = "icon"
      $favicon.href = link
      document.head.appendChild($favicon)
    }
  }

  handleLogout = () => {
    cleanStore()
  }

  render() {
    const {
      isLoggerdIn,
      banco,
      isValid
    } = this.state

    // const logo = 'https://credility-web-dev.mybluemix.net/images/logo-credility-orange.png'
    // if (!isValid) {
    //   return <Redirect to={{ pathname: '/404' }} />;
    // }
    return (
      <div className="App">
        {/* {isValid ? <header className={`App-header-${banco}`} >
          <img src={require(`./images/${banco}.png`)} className={`App-logo-${banco}`} alt="logo" />
          <div className="App-title">
            {
              isLoggerdIn ? (
                <div align="right">
                  <Button onClick={this.handleLogout} style={{ background: 'transparent', color: '#ffffff' }}>
                    <Icon name='sign out' />Guardar y salir
                  </Button>
                </div>
              ) : (
                  <span />
                )
            }
          </div>
        </header> : <Redirect to={{ pathname: '/404' }} />} */}
        {/* {isValid ? <header className={`App-header-${banco}`} >
          <img src={require(`./images/${banco}.png`)} className={`App-logo-${banco}`} alt="logo" />
          <div className="App-title">
            {
              isLoggerdIn || banco === 'callback' ? (
                <div align="right">
                  <Button onClick={this.handleLogout} style={{ background: 'transparent', color: '#ffffff' }}>
                    <Icon name='sign out' />Guardar y salir
                  </Button>
                </div>
              ) : (
                  <span />
                )
            }
          </div>
        </header> : <Redirect to={{ pathname: '/404' }} />} */}
        {isValid ?
          <header className={`App-header-${banco}`} >
            <img src={require(`./images/${banco}.png`)} className={`App-logo-${banco}`} alt="logo" />
            <div className="App-title">
              {
                isLoggerdIn || banco === 'callback' ? (
                  <div align="right">
                    <Button onClick={this.handleLogout} className={`button-${banco}3`} >
                      <Icon name='sign out' />Guardar y salir
                  </Button>
                  </div>
                ) : (
                    <span />
                  )
              }
            </div>
          </header> : <div>{banco === 'callback' ?
            <div className="App-title">
              {
                isLoggerdIn || banco === 'callback' ? (
                  <div align="right">
                    <Button onClick={this.handleLogout} className={`button-${banco}3`} >
                      <Icon name='sign out' />Guardar y salir
                  </Button>
                  </div>
                ) : (
                    <span />
                  )
              }
            </div> : <Redirect to={{ pathname: '/404' }} />}
          </div>}

        <br />
        <Container textAlign='left'>
          <AppRoutes isLoggerdIn={isLoggerdIn} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggerdIn: state.loginReducer.isLoggerdIn
})

const mapDispatchToProps = () => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/App.js